import axios from "axios";
import env from "../variables/EndpointEnvironment";

const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}

const KoreanLinkTitleAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/deskripsi-singkat?loc=korean_link${props}`,
    {
      headers
    }
  );
};

export default KoreanLinkTitleAPI;
